import { ContractorRecollection, RecollectionType } from 'src/interfaces/contractor'
import { CollectDataStepCreateSource } from 'src/constants/contractor/enums'
import { GIGSAFE_API_LABEL } from './constants'

export function getInitiatorLabel(recollection: ContractorRecollection): string | null {
  if (recollection.type !== RecollectionType.Manual) {
    return null
  }

  if (recollection.createInitiatorSource === CollectDataStepCreateSource.Api) {
    return GIGSAFE_API_LABEL
  }

  return recollection.initiatorEmail ?? null
}
